import { render } from "./ReviewPaper.vue?vue&type=template&id=45f1cfca&ts=true"
import script from "./ReviewPaper.vue?vue&type=script&lang=ts"
export * from "./ReviewPaper.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/shunta/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__